import React, { useEffect } from 'react';

import useWallet from 'components/Common/Members/Hooks/useWallet';
import { useContext as useUsersContext } from 'components/Users/Context';
import { Tabs, Tab } from 'react-bootstrap5';
import { useContext as useHomeContext } from 'components/Members/Home/Context';
import Breadcrumbs from 'components/new_ui/Breadcrumbs/Index';
import Statistics from './Statistics';
import Plans from './Plans';
import Invoices from './Invoices';

import Wait from './Wait';

import VoluntaryBenefits from './VoluntaryBenefits/Index';

export default function Main() {
  const { dispatch: dispatchUsers, actions: actionsUsers, state: stateUsers } = useUsersContext();

  const wallet = useWallet();

  const member = stateUsers.user?.attributes?.specific;

  const homeContext = useHomeContext();

  const breadcrumbs = [
    {
      name: 'Home',
      path: '/members/home',
    },
    {
      name: 'Wallet',
    },
  ];

  useEffect(() => {
    actionsUsers.load(dispatchUsers);
  }, []);

  if (wallet === null || stateUsers.user === null) {
    return <Wait />;
  }

  return (
    <>
      <div className="content wallet">
        {homeContext && <Breadcrumbs breadcrumbs={breadcrumbs} />}
        <section>
          <h1 className="mb-3">Wallet</h1>
        </section>

        <section>
          <Statistics wallet={wallet} />
        </section>

        {member.is_voluntary_benefit && (
          <Tabs
            defaultActiveKey="vbEnrollment"
            id="members-wallet"
            className="d-flex"
            justify
          >
            <Tab
              eventKey="vbEnrollment"
              title="VB Enrollment"
              className="px-sm-4 px-xxl-5"
            >
              <VoluntaryBenefits />
            </Tab>

            <Tab
              eventKey="memberInfo"
              title="Individual"
              className="px-sm-4 px-xxl-5"
            >
              <Plans wallet={wallet} member={stateUsers.user.attributes.specific} />
              <Invoices withSection={false} />
            </Tab>

          </Tabs>
        )}

        {!member.is_voluntary_benefit && (
          <section>
            <Plans wallet={wallet} member={stateUsers.user.attributes.specific} />
          </section>
        )}
      </div>
      {!member.is_voluntary_benefit && (
        <Invoices withSection />
      )}
    </>
  );
}
